import { Instagram } from "lucide-react";
import { useLenis } from "lenis/react";
import Logo from "@/components/Logo";
import { useSite } from "@/context/SiteContext";

const LEGACY_LINKS = [
  { label: "Inicio", target: "#inicio" },
  { label: "Descargas", target: "#descargas" },
  { label: "Video", target: "#video" },
  { label: "Contacto", target: "#contacto" },
];

export default function Footer() {
  const { content } = useSite();
  const c = content?.contact || {};
  const f = content?.footer || {};
  const nav = content?.nav || {};
  const links = (nav.links && nav.links.length) ? nav.links : LEGACY_LINKS;
  const lenis = useLenis();

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) (lenis ? lenis.scrollTo(el, { offset: -72 }) : el.scrollIntoView({ behavior: "smooth" }));
  };

  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[color:var(--aurex-surface-2)]">
      <div className="mx-auto max-w-[1400px] px-6 pt-16 md:px-10">
        <div className="flex flex-col justify-between gap-10 md:flex-row">
          <div className="max-w-sm">
            <Logo size={40} />
            <p className="mt-5 text-sm leading-relaxed text-[color:var(--aurex-muted)]">
              {content?.brand?.tagline} {f.description || "Notebooks de alta gama diseñadas para rendir sin límites."}
            </p>
          </div>
          <div className="flex gap-16">
            <div>
              <div className="font-mono-jb text-[10px] uppercase tracking-[0.2em] text-zinc-600">{f.nav_label || "Navegación"}</div>
              <ul className="mt-4 space-y-3 text-sm">
                {links.map((l) => (
                  <li key={l.target}>
                    <button
                      onClick={() => scrollTo(l.target)}
                      className="text-[color:var(--aurex-muted)] transition-colors hover:text-[color:var(--aurex-text)]"
                    >
                      {l.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="font-mono-jb text-[10px] uppercase tracking-[0.2em] text-zinc-600">{f.follow_label || "Seguinos"}</div>
              <a
                href={c.instagram_url || `https://instagram.com/${c.instagram}`}
                target="_blank"
                rel="noreferrer"
                className="mt-4 flex items-center gap-2 text-sm text-[color:var(--aurex-muted)] transition-colors hover:text-[color:var(--aurex-accent-soft)]"
              >
                <Instagram size={16} /> @{c.instagram}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 md:flex-row">
          <p className="font-mono-jb text-xs text-zinc-600">© {f.year || new Date().getFullYear()} {f.note}</p>
          <p className="font-mono-jb text-xs text-zinc-600">{c.address}</p>
        </div>
      </div>

      {f.show_big_text !== false && (
        <div className="select-none px-6 pb-6 text-center md:px-10">
          <span className="font-display text-[20vw] font-extrabold leading-none tracking-tighter text-white/[0.03] md:text-[16vw]">
            {f.big_text || content?.brand?.name || "AUREX"}
          </span>
        </div>
      )}
    </footer>
  );
}
